import React, { useEffect, useState } from 'react';
import { FaEraser, FaFilter } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';

export abstract class FilterModel {
  q?: string | null;
  skip: number;
  take: number;

  constructor(data: any = {}) {
    this.q = data.q;
    this.skip = data.skip || 0;
    this.take = data.take || 25;
  }

  abstract get totalFilters(): number;
}

interface FilterProps {
  isLoading: boolean;
  totalApplied: number;
  children: React.ReactNode;
  onSubmit: (data: any) => void;
  clear: () => void;
}

export default function Filter({
  isLoading,
  totalApplied,
  children,
  onSubmit,
  clear,
}: FilterProps) {
  const [isShow, setIsShow] = useState(false);

  const toggleFilters = () => {
    setIsShow(!isShow);
  };

  return (
    <>
      <div className='d-flex justify-content-end'>
        <button
          type='button'
          className='btn btn-secondary position-relative'
          onClick={() => toggleFilters()}
        >
          <FaFilter /> Filtros
          {totalApplied > 0 && (
            <span
              className='position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'
              style={{
                padding: '5px 8px',
              }}
            >
              {totalApplied}
              <span className='visually-hidden'>unread messages</span>
            </span>
          )}
        </button>
      </div>
      {isShow && (
        <div className='position-relative'>
          <div
            className='position-absolute border shadow end-0 bg-light rounded'
            style={{ zIndex: 1, top: '0.5rem', minWidth: '20rem' }}
          >
            <div className='d-flex justify-content-end p-2'>
              <button
                type='button'
                className='btn p-0 align-self-start'
                onClick={() => setIsShow(false)}
              >
                <IoMdClose size={20} />
              </button>
            </div>
            {isLoading ? (
              <div className='placeholder-glow'>
                <span className='placeholder placeholder-lg col-12' />
                <span className='placeholder placeholder-xs col-12 bg-dark' />
                <span className='placeholder col-12 bg-secondary' />
                <span className='placeholder col-12 bg-secondary' />
                <span className='placeholder col-12 bg-secondary' />
                <span className='placeholder col-12 bg-secondary' />
                <span className='placeholder col-12 bg-secondary' />
              </div>
            ) : (
              <>
                <div
                  className='overflow-auto p-2 m-2'
                  style={{ maxHeight: '20rem' }}
                >
                  {children}
                </div>
                <div className='d-flex justify-content-end p-3 gap-2'>
                  <button
                    type='button'
                    className='btn btn-secondary'
                    onClick={clear}
                  >
                    <FaEraser /> Limpar
                  </button>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={onSubmit}
                  >
                    Filtrar
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
